import { addNewRelicPageAction } from '@ddc/new-relic';
import { safeSessionStorage } from './safeStorage';

const wsTrackNr = (eventType) => {
	if (Math.floor(Math.random() * (100 - 0) + 1) <= 10) {
		addNewRelicPageAction('wsTrackingDebug', {
			eventName: eventType,
			userSessionId: safeSessionStorage.getItem('wsTrackingSessionId')
		});
	}
};

export const wsTrackNrFormConfirmation = (clickPath) => {
	addNewRelicPageAction('wsTrackNrFormConfirmation', {
		eventName: 'ddc.form.confirmation',
		userSessionId: safeSessionStorage.getItem('wsTrackingSessionId'),
		hasClickPath: Boolean(clickPath)
	});
};

export const wsTrackNrClickPathMissing = () => {
	addNewRelicPageAction('wsTrackingClickPathMissing', {
		eventName: 'ddc.form.confirmation',
		userSessionId: safeSessionStorage.getItem('wsTrackingSessionId')
	});
};

export const wsTrackNrBlockedFormConfirmation = (formEventId) => {
	addNewRelicPageAction('wsTrackNrBlockedFormConfirmation', {
		eventName: 'ddc.form.confirmation',
		formEventId,
		userSessionId: safeSessionStorage.getItem('wsTrackingSessionId')
	});
};

export default wsTrackNr;
